/* la Joie Atelier - cart drawer and search overlay.
   Behaviour for snippets/lja-overlays.liquid. The drawer contents are rendered
   from /cart.js, so the markup here mirrors renderCart() in the approved
   prototype rather than inventing a layout. The gift note is stored as the cart
   note and the birthday as the "Date of Birth" cart attribute - the same two
   places lja-cart.js writes on the /cart page, so the two stay in step. */
(function () {
  'use strict';

  var CFG = window.ljaOverlayConfig || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var panel = $('[data-lja-cart]');
  var searchbar = $('[data-lja-search]');
  if (!panel && !searchbar) return;

  var scrim = $('[data-lja-scrim]');
  var body = $('[data-lja-cart-bd]');
  var foot = $('[data-lja-cart-ft]');
  var countEls = $$('[data-lja-cart-count], [data-lja-cart-n]');

  var state = { note: '', dob: '', giftOpen: false, dobOpen: false, cart: null };

  /* ---------- helpers ---------- */

  function group(str) {
    var head = str, tail = '';
    var dot = str.indexOf('.');
    if (dot >= 0) { head = str.slice(0, dot); tail = str.slice(dot); }
    var out = '';
    for (var i = 0; i < head.length; i++) {
      if (i > 0 && (head.length - i) % 3 === 0) out += ',';
      out += head.charAt(i);
    }
    return out + tail;
  }

  function money(cents) {
    var v = (cents || 0) / 100;
    var withDec = group(v.toFixed(2));
    var noDec = group(Math.round(v).toString());
    var f = CFG.moneyFormat || '${{amount}}';
    return f.split('{{amount_no_decimals}}').join(noDec).split('{{amount}}').join(withDec);
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- line classification ---------- */

  function membership(item) {
    var h = item.handle || '';
    if (h.indexOf('mail-club') < 0) return null;
    var term = '';
    (item.options_with_values || []).forEach(function (o) {
      if (/membership/i.test(o.name)) term = o.value;
    });
    if (!term) term = (item.variant_title || '').split(' / ').pop() || '';
    return {
      kind: h.indexOf('digital') >= 0 ? 'digital' : 'physical',
      term: term,
      prepaid: term.indexOf('Month-to-Month') < 0
    };
  }

  function optionLine(item) {
    var parts = [];
    (item.options_with_values || []).forEach(function (o) {
      if (o.value && o.value !== 'Default Title') parts.push(o.value);
    });
    parts.push('Qty ' + item.quantity);
    return parts.join(' &middot; ');
  }

  /* ---------- rendering ---------- */

  function lineHtml(item, index) {
    var sub = membership(item);
    var img = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" width="160" height="160" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block">'
      : '';
    var flagClass = sub ? (sub.prepaid ? 'prepay' : 'm2m') : 'once';
    var flagText = sub
      ? (sub.prepaid ? 'Prepaid membership &mdash; does not auto-renew' : 'Month-to-month membership')
      : 'One-time purchase';
    var meta = sub
      ? '<div class="meta">' + esc(sub.term) + '</div>' +
        '<div class="meta">' + (sub.prepaid ? 'One payment &middot; does not auto-renew' : 'This Edition only &middot; nothing is charged automatically') + '</div>' +
        '<div class="meta" style="color:var(--sage-deep)">' + (sub.kind === 'digital' ? 'Files only &mdash; no physical delivery is included' : 'One Mail Club delivery') + '</div>'
      : '<div class="meta">' + optionLine(item) + '</div>';

    return '<div style="display:flex;gap:14px;padding:14px 0;border-bottom:1px solid var(--rule)">' +
      '<div style="width:74px;flex:0 0 auto;border-radius:3px;overflow:hidden;aspect-ratio:1;background:var(--linen)">' + img + '</div>' +
      '<div style="flex:1">' +
        '<span class="lineflag ' + flagClass + '">' + flagText + '</span>' +
        '<div style="font-family:var(--f-display);font-size:15px;line-height:1.25">' + esc(item.product_title) + '</div>' +
        meta +
        '<div class="price" style="margin-top:5px">' + money(item.final_line_price) + '</div>' +
        '<div class="lja-qty" style="margin-top:8px;display:flex;align-items:center;gap:10px">' +
          '<button type="button" class="iconbtn" data-lja-qty="' + (index + 1) + '" data-lja-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<span class="meta" style="min-width:1.5em;text-align:center">' + item.quantity + '</span>' +
          '<button type="button" class="iconbtn" data-lja-qty="' + (index + 1) + '" data-lja-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '<button type="button" class="lnk" style="font-size:11px;margin-left:6px" data-lja-qty="' + (index + 1) + '" data-lja-to="0">Remove</button>' +
        '</div>' +
      '</div></div>';
  }

  function noticeHtml(cart) {
    var hasSub = false, hasPrepay = false, hasM2M = false, hasPhys = false;
    cart.items.forEach(function (i) {
      var s = membership(i);
      if (s) { hasSub = true; if (s.prepaid) hasPrepay = true; else hasM2M = true; if (s.kind === 'physical') hasPhys = true; }
      else hasPhys = true;
    });
    var out = '<div style="margin-top:18px;padding:16px;background:var(--sage-tint);border-radius:4px">';
    out += hasPhys
      ? '<p class="meta" style="color:var(--sage-deep);font-weight:600">Free worldwide shipping applied.</p>' +
        '<p class="meta" style="margin-top:5px">Duties and import taxes are calculated at checkout where applicable.</p>'
      : '<p class="meta" style="color:var(--sage-deep);font-weight:600">Digital delivery &mdash; nothing in this cart is shipped.</p>';
    if (hasSub) {
      var mid = (hasPrepay && hasM2M)
        ? 'Your prepaid membership is one payment, and your month-to-month Edition is a single purchase.'
        : hasPrepay
          ? 'A prepaid membership is one payment for the full term.'
          : 'A month-to-month membership is a single purchase of one Edition &mdash; we will email you when the next opens.';
      out += '<p class="meta" style="margin-top:9px;color:var(--walnut)"><strong>Nothing in this cart renews automatically.</strong> ' + mid + ' We never charge your card automatically.</p>';
    }
    return out + '</div>';
  }

  function fieldsHtml() {
    return '' +
      '<div class="gift">' +
        '<button type="button" class="gifttog" data-lja-gift-tog aria-pressed="' + state.giftOpen + '" aria-expanded="' + state.giftOpen + '" aria-controls="lja-gift-body">' +
          '<span class="box"></span><span>Is this a gift?</span></button>' +
        '<div class="giftbody' + (state.giftOpen ? ' on' : '') + '" id="lja-gift-body">' +
          '<label class="sr" for="lja-gift-note">Gift note</label>' +
          '<textarea id="lja-gift-note" data-lja-gift-note maxlength="250" placeholder="Add a gift note &mdash; we write it out by hand and include it with your order.">' + esc(state.note) + '</textarea>' +
          '<div class="giftmeta"><span>Handwritten by us, free of charge.</span>' +
            '<span class="cnt" data-lja-gift-count>' + state.note.length + ' / 250</span></div>' +
        '</div>' +
      '</div>' +
      '<div class="gift">' +
        '<button type="button" class="gifttog" data-lja-dob-tog aria-pressed="' + state.dobOpen + '" aria-expanded="' + state.dobOpen + '" aria-controls="lja-dob-body">' +
          '<span class="box"></span><span>Add your date of birth <em class="dobopt">optional</em></span></button>' +
        '<div class="giftbody' + (state.dobOpen ? ' on' : '') + '" id="lja-dob-body">' +
          '<label class="sr" for="lja-dob">Date of birth</label>' +
          '<input type="date" id="lja-dob" class="dobin" data-lja-dob value="' + esc(state.dob) + '" autocomplete="bday">' +
          '<div class="giftmeta"><span>Used only for birthday messages and occasional la Joie surprises. It does not subscribe you to anything.</span></div>' +
        '</div>' +
      '</div>';
  }

  function render(cart) {
    state.cart = cart;
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!cart.items.length) {
      body.innerHTML = '<p class="ed">Nothing here yet.</p>' +
        '<p style="margin-top:18px"><a class="btn ghost sm" href="' + esc(CFG.browseUrl || '/collections/all') + '">Browse the kits</a></p>';
      foot.hidden = true;
      foot.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items.map(lineHtml).join('') + fieldsHtml() + noticeHtml(cart);

    var hasSub = cart.items.some(function (i) { return !!membership(i); });
    foot.hidden = false;
    foot.innerHTML =
      '<div style="display:flex;justify-content:space-between;margin-bottom:14px">' +
        '<span class="meta">Subtotal</span>' +
        '<span class="price" style="font-size:17px">' + money(cart.total_price) + '</span></div>' +
      '<a class="btn wide" href="/checkout">Checkout</a>' +
      '<div class="paytrust">' +
        (CFG.payMark ? '<img src="' + esc(CFG.payMark) + '" alt="Pay with iyzico">' : '') +
        '<span>Card payments are processed securely by iyzico. Visa, Mastercard, American Express and Troy accepted.</span></div>' +
      (hasSub ? '<p class="meta" style="margin-top:10px;text-align:center">We never charge your card automatically.</p>' : '');
  }

  function refresh() {
    return getCart().then(function (cart) {
      state.note = cart.note || '';
      var attrs = cart.attributes || {};
      state.dob = attrs['Date of Birth'] || '';
      if (state.note) state.giftOpen = true;
      if (state.dob) state.dobOpen = true;
      render(cart);
      return cart;
    });
  }

  /* ---------- open / close ---------- */

  function closeAll() {
    if (panel) { panel.classList.remove('on'); panel.setAttribute('aria-hidden', 'true'); }
    if (searchbar) { searchbar.classList.remove('on'); searchbar.setAttribute('aria-hidden', 'true'); }
    if (scrim) scrim.classList.remove('on');
  }

  function openCart() {
    if (!panel) return;
    if (searchbar) { searchbar.classList.remove('on'); searchbar.setAttribute('aria-hidden', 'true'); }
    panel.classList.add('on');
    panel.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    var close = panel.querySelector('[data-lja-overlay-close]');
    if (close) close.focus();
  }

  function openSearch() {
    if (!searchbar) return;
    if (panel) { panel.classList.remove('on'); panel.setAttribute('aria-hidden', 'true'); }
    searchbar.classList.add('on');
    searchbar.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    setTimeout(function () { var i = $('#lja-search-input'); if (i) i.focus(); }, 120);
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var openC = e.target.closest('[data-lja-cart-open]');
    if (openC) { e.preventDefault(); refresh().then(openCart); return; }

    var openS = e.target.closest('[data-lja-search-open]');
    if (openS) { e.preventDefault(); openSearch(); return; }

    if (e.target.closest('[data-lja-overlay-close]')) { e.preventDefault(); closeAll(); return; }
    if (scrim && e.target === scrim) { closeAll(); return; }

    var qty = e.target.closest('[data-lja-qty]');
    if (qty) {
      e.preventDefault();
      var line = parseInt(qty.getAttribute('data-lja-qty'), 10);
      var to = parseInt(qty.getAttribute('data-lja-to'), 10);
      if (to < 0) return;
      post(CFG.cartChangeUrl || '/cart/change.js', { line: line, quantity: to }).then(render);
      return;
    }

    var gt = e.target.closest('[data-lja-gift-tog]');
    if (gt) { state.giftOpen = !state.giftOpen; render(state.cart); if (state.giftOpen) { var t = $('[data-lja-gift-note]'); if (t) t.focus(); } return; }

    var dt = e.target.closest('[data-lja-dob-tog]');
    if (dt) { state.dobOpen = !state.dobOpen; render(state.cart); if (state.dobOpen) { var d = $('[data-lja-dob]'); if (d) d.focus(); } return; }
  });

  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-lja-gift-note]')) return;
    state.note = e.target.value.slice(0, 250);
    var c = $('[data-lja-gift-count]');
    if (c) { c.textContent = state.note.length + ' / 250'; c.classList.toggle('warn', state.note.length > 230); }
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post(CFG.cartUpdateUrl || '/cart/update.js', { note: state.note }); }, 450);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-lja-dob]')) return;
    state.dob = e.target.value;
    post(CFG.cartUpdateUrl || '/cart/update.js', { attributes: { 'Date of Birth': state.dob } });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Add to cart without leaving the page, then show the drawer. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') < 0) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(CFG.cartAddUrl || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) btn.removeAttribute('aria-busy');
      if (res && res.status && res.status !== 200) { form.submit(); return; }
      refresh().then(openCart);
    }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
  });

  refresh();
})();
